export const wait = (ans, time) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(ans);
    }, time);
  });

export const wrapWait = time => d => wait(d, time);
